import { consts } from '../actions/differentialAdvantageActions';

const initialState = {
    createDifferentialAdvantageData: {},
    createDifferentialAdvantageFetching: false,
    createDifferentialAdvantageFetched: false,
    getDifferentialAdvantageData: {},
    getDifferentialAdvantageFetching: false,
    getDifferentialAdvantageFetched: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {

        case consts.CREATE_DIFFERENTIAL_ADVANTAGE_PENDING : {
            state = Object.assign({}, state, {createDifferentialAdvantageFetching: true, createDifferentialAdvantageFetched: false});
            break;
        }
        case consts.CREATE_DIFFERENTIAL_ADVANTAGE_FULFILLED: {
            state = Object.assign({}, state, { createDifferentialAdvantageFetching: false, createDifferentialAdvantageFetched: true, createDifferentialAdvantageData: action.data});
            break;
        }
        case consts.CREATE_DIFFERENTIAL_ADVANTAGE_REJECTED: {
            state = Object.assign({}, state, { createDifferentialAdvantageFetching: false, createDifferentialAdvantageFetched: false, createDifferentialAdvantageData:{}, createPrioritizerError: action.error });
            break;
        }

        case consts.GET_DIFFERENTIAL_ADVANTAGE_PENDING : {
            state = Object.assign({}, state, {getDifferentialAdvantageFetching: true, getDifferentialAdvantageFetched: false});
            break;
        }
        case consts.GET_DIFFERENTIAL_ADVANTAGE_FULFILLED: {
            state = Object.assign({}, state, { getDifferentialAdvantageFetching: false, getDifferentialAdvantageFetched: true, getDifferentialAdvantageData: action.data});
            break;
        }
        case consts.GET_DIFFERENTIAL_ADVANTAGE_REJECTED: {
            state = Object.assign({}, state, { getDifferentialAdvantageFetching: false, getDifferentialAdvantageFetched: false, getDifferentialAdvantageData:{}, getPrioritizerError: action.error });
            break;
        }        

    }
    return state;
}


// WEBPACK FOOTER //
// ./src/store/reducers/differentialAdvantageReducer.jsx